<template>
  <div class="email-box">
    <label class="chat-widget-container">
    </label>
    <div style="text-align: center;">
      <input 
        v-model.trim="email"
        type="email"
        class="email"
        :placeholder="placeholder_email"
      />
      <input 
        v-model.trim="firstname"
        type="text"
        class="firstname"
        :placeholder="placeholder_firstname"
      />
      <button :disabled="!email && !firstname" @click="submit">
        {{ $t(button) }}
      </button>
    </div>
  </div>
</template>

<script>
import styleProfile from "@/style-profile";
import { customLogger } from "@/utils";

const store = require("@/store").default;
export default {
name: "BoxEmailFirstname",
components: {},
data: () => {
    return {
    email: "",
    firstname: "",
    message: (store.state.user.lang === "en") ? "While waiting for an agent to become available ..." : "En attendant qu’un agent se libère …",
    placeholder_email: (store.state.user.lang === "en") ? "Enter your email here" : "Entrez votre email ici",
    placeholder_firstname: (store.state.user.lang === "en") ? "Enter your firstname here" : "Entrez votre prénom ici",
    button: (store.state.user.lang === "en") ? "Submit" : "Valider"
  };
},
computed: {},
mounted() {},
methods: {
    submit() {
    //customLogger('test voir si ça passe bien pas là\n')
    let email = this.email;
    let firstname = this.firstname;
    this.$eb.emit("BoxUserInfo", {email, firstname}, document.location.href);
    return;
    },
},
};
</script>